import { PocoStyled, PocoStyled2 } from "../Styles/Poco";
import line from "../Assets/Icons/Line.svg";
import { HomeContext } from "../Context/ContextHome";
import { useContext } from "react";

export const Poco = ({ alturaAtual }) => {
  const { darkMode } = useContext(HomeContext);

  return (
    <PocoStyled agua={alturaAtual} darkmode={darkMode}>
      <div className="conteinerBarra">
        <div className="circle"></div>
        <div className="liquido">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#60ABFF"
              fill-opacity="1"
              d="M0,64L80,101.3C160,139,320,213,480,224C640,
                        235,800,181,960,149.3C1120,117,1280,107,
                        1360,101.3L1440,96L1440,320L1360,320C1280,
                        320,1120,320,960,320C800,320,640,320,480,320C320,
                        320,160,320,80,320L0,320Z"
            ></path>
          </svg>
        </div>
      </div>
    </PocoStyled>
  );
};

export const PocoHome = ({ alturaAtual, nivelExtravasor, nivelMinimo }) => {
  return (
    <PocoStyled2
      agua={alturaAtual}
      nivel={nivelExtravasor}
      nivelM={nivelMinimo}
    >
      <div className="conteinerBarra">
        <div className="circle"></div>
        <div className="liquido">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
            className="onda"
          >
            <path
              fill="#60ABFF"
              fill-opacity="1"
              d="M0,64L80,101.3C160,139,320,213,480,224C640,
                        235,800,181,960,149.3C1120,117,1280,107,
                        1360,101.3L1440,96L1440,320L1360,320C1280,
                        320,1120,320,960,320C800,320,640,320,480,320C320,
                        320,160,320,80,320L0,320Z"
            ></path>
          </svg>
        </div>
        <div className="marcacao">
          <span>{Math.floor(alturaAtual)}%</span>
        </div>
        <div className="extravasor">
          <div className="lineMarcacao">
            <span className="linha"></span>
            <span className="name">Extravasor</span>
          </div>
        </div>
        <div className="nivelminimo">
          <div className="lineMarcacao">
            <span className="linha"></span>
            <span className="name">Nível Mínimo</span>
          </div>
        </div>
      </div>
    </PocoStyled2>
  );
};
